import { t } from "../../services/formatters";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { FormDatiUtente } from "../../components/FormDatiUtente";
import { Informative } from "../../components/Informative";
import { useDatiPersonaliNonRiconosciutoPage } from "./useDatiPersonaliNonRiconosciutoPage";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import { Riepilogo } from "../../components/Riepilogo";
import { useComponentMetric } from "../../lib/otel";
import "./DatiPersonaliNonRiconosciutoPage.css";

export const DatiPersonaliNonRiconosciutoPage = () => {
    const { next, read, isCreaAppuntamentoBusy, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliNonRiconosciutoPage();

    useComponentMetric("dati-non-riconosciuto", { fetchError, fetchErrorMessage, fallbackErrorMessage: "errore creazione appuntamento" });

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa-mps/fissa-appuntamento/dati-personali",
            crmIdentification: "nuovo utente",
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="dati-personali-non-riconosciuto-page">
            <Breadcrumb />

            <Riepilogo />

            <FormDatiUtente title={t("compila_dati")} />

            <Informative />

            <div className="section text-center">
                <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>
        </div>
    );
};
